var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-notice"},[_c('div',{staticClass:"title"},[_vm._v("유의사항")]),_c('div',{staticClass:"content"},[_c('ul',[_c('li',[_vm._v("동일 연구실 소속이라면 장바구니에 담긴 상품이 연동됩니다. 다만 상품 연동에 약간의 지연이 있을 수 있습니다.")]),_c('li',[_vm._v("장바구니 내의 상품 가격은 판매사의 사정에 의해 언제든 변동될 수 있습니다.")])])])])
}]

export { render, staticRenderFns }